function LinkAccounts() {
  return (
    <svg width="72" height="8" viewBox="0 0 72 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="4" cy="4" r="4" fill="#D9D9D9" />
      <circle cx="20" cy="4" r="4" fill="#D9D9D9" />
      <circle cx="52" cy="4" r="4" fill="#D9D9D9" />
      <circle cx="36" cy="4" r="4" fill="#D9D9D9" />
      <circle cx="68" cy="4" r="4" fill="#D9D9D9" />
    </svg>
  )
}

export default LinkAccounts
